import {h, Component} from 'preact';
import ReactTelInput from 'react-telephone-input/lib/withStyles';
import HelpService from '../../services/helpService';
import Util from '../../services/util';
import Modal from '../tags/modal';
import CloseButtonWithCircle from '../tags/close-button-with-circle';
import { SessionStorageKeys } from '../../services/sessionStorageKeys.const';

export class SupportFormModal extends Component {
    constructor() {
        super();
        this.state = {
            helpInfo: {},
            isMobile: Util.isMobile(),
            userName: '',
            email: '',
            company: '',
            phoneNumber: '',
            ticketContent: '',
            submitFormLoading: false,
            defaultCountry: '',
            userNameError: false,
            emailError: false,
            phoneNumberError: false,
            ticketContentError: false,
            formError: '',
            formSubmitted: false
        }
    }

    componentDidMount() {
        this.setState({
            helpInfo: this.props.helpInfo,
            userName: this.props.userName,
            email: this.props.email,
            company: this.props.company
        });
    }

    componentDidUpdate(previousProps, previousState, previousContext) {
        if ( previousProps.helpInfo !== this.props.helpInfo && this.props.helpInfo) {
            this.setState({ helpInfo: this.props.helpInfo });
        }
        if (previousProps.userName !== this.props.userName) {
            this.setState({ userName: this.props.userName });
        }
        if (previousProps.email !== this.props.email) {
            this.setState({ email: this.props.email });
        }
        if (previousProps.company !== this.props.company) {
            this.setState({ company: this.props.company });
        }
    }

    onUserInfoInput = (e, userInfo) => {
        const state = { formError: '' };
        state[`${userInfo}Error`] = false;
        state[userInfo] = e.target.value;
        this.setState({ ...state });
    };

    onUserInfoBlur = (e, userInfo) => {
        if (!e.target.value) {
            const state = {};
            state[`${userInfo}Error`] = true;
            this.setState({ ...state });
        }
    };

    onPhoneNumberChange = phoneNumber => {
        this.setState({ phoneNumberError: false, formError: '', phoneNumber: `+${phoneNumber.replace(/\D/g, '')}` });
    };

    onPhoneNumberBlur = phoneNumber => {
        if (!phoneNumber || phoneNumber.length < 6) {
            this.setState({ phoneNumberError: true });
        }
    };

    onFormSubmit = e => {
        e.preventDefault();
        this.submitSupportForm()
    };

    submitSupportForm = () => {
        if (!this.state.userName) {
            this.setState({ userNameError: true, formError: 'This field is required' });
        } else if (!this.state.email) {
            this.setState({ emailError: true, formError: 'This field is required' });
        } else if (!this.state.email.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
            this.setState({ emailError: true, formError: 'Please enter a valid email' });
        } else if (!this.state.phoneNumber || this.state.phoneNumber.length < 6) {
            this.setState({ phoneNumberError: true, formError: 'This field is required' });
        } else if (!this.state.ticketContent.match(/[a-zA-Z]/)) {
            this.setState({ ticketContentError: true, formError: 'This field is required' });
        } else {
            this.setState({ submitFormLoading: true, formError: '' });
            const data = {
                displayName: this.state.userName,
                email: this.state.email,
                phone: this.state.phoneNumber,
                description: this.state.ticketContent,
                company: this.state.company
            };
            HelpService.submitSupportForm(data)
                .then(() => {
                    this.setState({ submitFormLoading: false, formSubmitted: true, formError: '' });
                }, () => {
                    this.setState({ formError: 'We have trouble contacting support server, please try again later.' });
                })
        }
    };

    openModal = () => {
        this.child.openModal();
    };

    closeModal = () => {
        this.child.closeModal();
        setTimeout(() => {
            this.setState({
                userName: '',
                email: '',
                company: '',
                phoneNumber: '',
                ticketContent: '',
                submitFormLoading: false,
                userNameError: false,
                emailError: false,
                phoneNumberError: false,
                ticketContentError: false,
                formError: '',
                formSubmitted: false
            });
        }, 500);
    };

    renderCloseButton = () => {
        if (this.props.hideClose) {
            return null;
        }
        return <CloseButtonWithCircle action={this.closeModal}/>;
    };

    renderCopy = () => {
        if (this.props.hasError) {
            return <p>Please wait a moment and try reloading this page.</p>;
        }

        if (this.state.formSubmitted) {
            if (this.state.isMobile) {
                return <p className='gray-text'>Your ticket has been confirmed. You should receive a response in a few hours. For urgent matters during office hours, please call support.</p>
            }
            return (
                <p>Your ticket has been confirmed. You should receive a response in a few hours.<br/>
                    For urgent matters during office hours, please call support.</p>
            );
        } else {
            if (this.state.isMobile) {
                return (
                    <p className='gray-text'>We’re sorry you’re having trouble with Workplace. {this.state.helpInfo.email ? 'Call or send us a message below' : 'Call us'}. We’re here to help.</p>
                );
            }
            return (
                <p>We’re sorry you’re having trouble with Workplace.<br/>
                    {this.state.helpInfo.email ? 'Call or send us a message below' : 'Call us'} — we’re here to help.
                </p>
            );
        }
    };

    renderForm = () => {
        if (this.state.helpInfo.email && !this.state.formSubmitted) {
            return (
                <form className='row no-gutters' onSubmit={this.onFormSubmit}>
                    <div className={`user-info col p-0 ${this.state.isMobile ? 'col-12' : 'col-6 pr-3'}`}>
                        <div className='form-group'>
                            <label htmlFor='userName'>Your name</label>
                            <input className={`form-control ${this.state.userNameError ? 'invalid' : ''}`}
                                   id='userName'
                                   name='userName'
                                   type='text'
                                   value={this.state.userName}
                                   onInput={e => {this.onUserInfoInput(e,'userName')}}
                                   onBlur={e => {this.onUserInfoBlur(e,'userName')}}
                            />
                        </div>
                        <div className='form-group'>
                            <label htmlFor='email'>Work email</label>
                            <input className={`form-control ${this.state.emailError ? 'invalid' : ''}`}
                                   id='email'
                                   name='email'
                                   type='email'
                                   value={this.state.email}
                                   onInput={e => {this.onUserInfoInput(e,'email')}}
                                   onBlur={e => {this.onUserInfoBlur(e,'email')}}
                            />
                        </div>
                    </div>
                    <div className={`user-info col p-0 ${this.state.isMobile ? 'col-12' : 'col-6 pl-3'}`}>
                        <div className={`form-group ${sessionStorage.getItem(SessionStorageKeys.guestAccess) === 'true' ? 'hidden' : ''}`}>
                            <label htmlFor='company'>Company</label>
                            <input className='form-control'
                                   id='company'
                                   name='company'
                                   type='text'
                                   value={this.state.company}
                                   onInput={e => {this.onUserInfoInput(e,'company')}}
                            />
                        </div>
                        <div className='form-group'>
                            <label>Phone</label>
                            <ReactTelInput
                                className={`${this.state.phoneNumberError ? 'invalid-phone' : ''}`}
                                value={this.state.phoneNumber.replace(/\D/g, '')}
                                defaultCountry={this.state.defaultCountry || 'us'}
                                preferredCountries={['us', 'ru', 'gb', 'au']}
                                flagsImagePath='img/flags.png'
                                onChange={this.onPhoneNumberChange}
                                onBlur={this.onPhoneNumberBlur}
                            />
                        </div>
                    </div>
                    <div className='ticket-content col col-12'>
                        <div className='form-group'>
                            <label htmlFor='ticketContent'>How can we help you?</label>
                            <textarea className={`form-control ${this.state.ticketContentError ? 'invalid' : ''}`}
                                      id='ticketContent'
                                      name='ticketContent'
                                      cols='30'
                                      rows='10'
                                      maxLength='512'
                                      value={this.state.ticketContent}
                                      onInput={e => {this.onUserInfoInput(e,'ticketContent')}}
                                      onBlur={e => {this.onUserInfoBlur(e,'ticketContent')}}
                            />
                        </div>
                    </div>
                    <input type="submit" className="hidden" />
                </form>
            );
        }
        return null;
    };

    renderModalFooter = () => {
        if (this.state.helpInfo.email && !this.state.formSubmitted) {
            return (
                <div className='w-modal-footer d-flex justify-content-end align-items-center'>
                    <p className={`error-message d-flex ${this.state.formError ? '' : 'hidden'}`}>
                        <span className='wi wi-warning' /><span>{this.state.formError}</span>
                    </p>
                    <a className={`button button-prime ${this.state.submitFormLoading ? 'loading' : ''}`}
                       onClick={this.submitSupportForm}>Send</a>
                </div>
            )
        }

        if (this.state.helpInfo.email && this.state.formSubmitted && !this.props.hideClose) {
            return (
                <div className='w-modal-footer d-flex justify-content-end'>
                    <a className='button button-prime' onClick={this.closeModal}>Done</a>
                </div>
            )
        }

        return null;
    };

    render({hideClose, isModalLoading, hasError}, {helpInfo, isMobile, formSubmitted}) {
        return(
            <Modal ref={instance => { this.child = instance; }}
                   modalClass={`support-form-modal ${formSubmitted ? 'form-submitted' : ''} ${isModalLoading || hasError || !helpInfo.email || (hideClose && formSubmitted) ? 'no-footer' : ''}`}
                   modalHeaderText={hasError && !isModalLoading ? 'We’re sorry. Something went wrong…' : 'Get help. Get back to work.'}>
                {(() => {
                    return (
                        <div>
                            {isModalLoading ? (
                                <div className={`w-modal-body`}>
                                    <div className={`mobile-loader`}> </div>
                                </div>
                            ) : (
                                <div>
                                    {this.renderCloseButton()}
                                    <div className={`w-modal-body`}>
                                        <section className={`support-form-wrapper`}>
                                            {this.renderCopy()}
                                            <div className={`phone-support-info ${this.state.isMobile ? '' : 'd-flex'} ${this.state.helpInfo.phone ? '' : 'hidden'}`}>
                                                <h5>Phone support: {this.state.helpInfo.phone}</h5>
                                                <p className={`gray-text ${this.state.helpInfo.phoneHours ? '' : 'hidden'}`}> {this.state.helpInfo.phoneHours}</p>
                                            </div>
                                            {this.renderForm()}
                                        </section>
                                    </div>
                                    {this.renderModalFooter()}
                                </div>
                            )}
                        </div>
                    )
                })()}
            </Modal>
        )
    }
}

export default SupportFormModal;




// WEBPACK FOOTER //
// ./src/scripts/views/help/support-form-modal.js